import dvaModelExtend from 'dva-model-extend';

import { bindServices } from '@/services/api';
import { createCrudModel } from '@/utils/core/dva';

import { ENTITY_NAME, FETCH_PARAMS, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);

const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute: FETCH_ROUTE,
  fetchParams: FETCH_PARAMS,
  entityName: ENTITY_NAME,
  api,
  features: { import: true, bulkActions: true },
  state: {
    isConfig: false,
    idSelected: '',
    selectedItem: null,
    /** Row action spinner (publish / generate-deactivate public URL). */
    rowActionLoadingItemIds: {},
  },
  effects: {
    *openModalConfig({ payload }, { put, select }) {
      try {
        const state = yield select((s) => s[MODEL_NAME]);
        const portalItem = (state.list || []).find((item) => item.id === payload.id);

        yield put({
          type: 'queryGetConfig',
          payload: {
            idSelected: payload.id,
            selectedItem: portalItem || null,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *generateUrl({ payload }, { call, put }) {
      yield put({ type: 'queryRowActionLoading', payload: { id: payload, active: true } });
      try {
        yield call(api.exec, {
          route: `${FETCH_ROUTE}/generatePublicUrl/${payload}`,
          httpMethod: 'post',
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'success', payload: { success: true } });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      } finally {
        yield put({ type: 'queryRowActionLoading', payload: { id: payload, active: false } });
      }
    },

    *desactivateUrl({ payload }, { call, put }) {
      yield put({ type: 'queryRowActionLoading', payload: { id: payload, active: true } });
      try {
        yield call(api.exec, {
          route: `${FETCH_ROUTE}/deactivatePublicUrl/${payload}`,
          httpMethod: 'post',
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'success', payload: { success: true } });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      } finally {
        yield put({ type: 'queryRowActionLoading', payload: { id: payload, active: false } });
      }
    },

    *publish({ payload }, { call, put }) {
      yield put({ type: 'queryRowActionLoading', payload: { id: payload, active: true } });
      try {
        yield call(api.exec, {
          route: `${FETCH_ROUTE}/publish/${payload}`,
          httpMethod: 'post',
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      } finally {
        yield put({ type: 'queryRowActionLoading', payload: { id: payload, active: false } });
      }
    },

    *clearConfigCache(_, { put }) {
      yield put({
        type: 'processPortalConfig/clearConfigCache',
      });
    },
  },
  reducers: {
    queryGetConfig(state, { payload }) {
      return {
        ...state,
        isConfig: true,
        idSelected: payload.idSelected,
        selectedItem: payload.selectedItem || state.selectedItem,
      };
    },

    hideConfig(state) {
      return {
        ...state,
        selectedItem: null,
        isConfig: false,
        idSelected: '',
      };
    },

    queryRowActionLoading(state, { payload }) {
      const rowActionLoadingItemIds = { ...(state.rowActionLoadingItemIds || {}) };
      const { id, active } = payload;
      if (!id) return state;
      if (active) {
        rowActionLoadingItemIds[id] = true;
      } else {
        delete rowActionLoadingItemIds[id];
      }
      return { ...state, rowActionLoadingItemIds };
    },
  },
});

export default dvaModelExtend(_model, { namespace: MODEL_NAME });
